module.exports = __webpack_public_path__ + "img/et.ed864863.svg";